import { FormTextInputComponent } from 'src/features/generalForms/builder/types/TextInput';
import { FormTextInput } from './formTextInput';

export const FormMultipleTextInput: FormTextInputComponent = (props) => <FormTextInput type={'text-area'} {...props} />;
